// extracted by extract-css-chunks-webpack-plugin
module.exports = {"switcher":"organization-switcher__switcher--1yvu_"};